export const banner = require("./image/hero-banner.png");
// export const logo = require("./image/logo.png"); 
export const check = require("./image/check.png")
export const finallogo = require("./image/finallogo.png"); 
export const category1 = require("./image/category1.png");
export const category2 = require("./image/category2.png");
export const category3 = require("./image/category3.png");
export const category4 = require("./image/category4.png");
export const category5 = require("./image/category5.png");
export const category6 = require("./image/category6.png");
export const brand1 = require("./image/brand1.png");
export const brand2 = require("./image/brand2.png");
export const brand3 = require("./image/brand3.png");
export const brand4 = require("./image/brand4.png");
export const brand5 = require("./image/brand5.png");
export const brand6 = require("./image/brand6.png");
export const pr1 = require("./image/pr1.png");
export const pr2 = require("./image/pr2.png");
export const pr3 = require("./image/pr3.png");
export const pr4 = require("./image/pr4.png");
export const pr5 = require("./image/pr5.png");
export const pr6 = require("./image/pr6.png");
export const pr7 = require("./image/pr7.png");
export const pr8 = require("./image/pr8.png");
export const pr9 = require("./image/pr9.png");
export const pr10 = require("./image/pr10.png");
export const pr11 = require("./image/pr11.png");
export const pr12 = require("./image/pr12.png");
export const pr13 = require("./image/pr13.png");
export const pr14 = require("./image/pr14.png");
export const pr15 = require("./image/pr15.png");
export const pr16 = require("./image/pr16.png");
export const pr17 = require("./image/pr17.png");
export const pr18 = require("./image/pr18.png");
export const health1 = require("./image/health1.png");
export const health2 = require("./image/health2.png");
export const health3 = require("./image/health3.png");
export const health4 = require("./image/health4.png");
export const health5 = require("./image/health5.png");
export const health6 = require("./image/health6.png");
export const health7 = require("./image/health7.png");
export const health8 = require("./image/health8.png");
export const health9 = require("./image/health9.png");
export const health10 = require("./image/health10.png");
export const frame = require("./image/Frame.png");
export const discount1 = require("./image/discount1.png");
export const discount2 = require("./image/discount2.png");
export const search = require("./image/search.png")

export const productdetails1 = require("./image/Group 116.png")
export const productdetails2 = require("./image/Group.png")
export const productdetails3 = require("./image/Group1.png")
export const imageprofiledefault = require("./image/Group 184.png")



export const carbon_location = require("./image/carbon_location.png")
export const cross = require("./image/Vector (3).png")
export const discounticons = require("./image/Vector.png")
export const offersicons1 = require("./image/Vector (1).png")
export const discounticons2 = require("./image/Group-not-ff.png")

